import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
  message,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_review,
  req_downloadfile_tqa_worker,
  req_list_tqa_department_log,
  req_single_tqa_reviewCheck,
  req_edit_tqa_reviewOpinion,
  req_edit_tqa_reviewCheck,
  req_add_tqa_log,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getNowAcademicYear } from "../../utils/dateUtil";

import WorkerModifyModal from "./manage-worker-modify-modal";
import HistoryLogsDepartmentModal from "./history-logs-department-modal";
import ReviewSchoolOpinionModal from "./review-school-opinion-modal";
import ReviewSchoolCheckModal from "./review-school-check-modal";
import ReviewSchoolBrowseModal from "./review-school-browse-modal";

class ReviewDepartmentList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    checkdata: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    academicYear: getNowAcademicYear(new Date()),
    isSubmited: false,
    isShowModal: false,
    isEditModal: false,
    isLogModal: false,
    isCheckModal: false,
    isOpinionModal: false,
    isPreviewModal: false,
    logs: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_review(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      "COLLEGE",
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      // 設定審查者狀態
      const item = {
        WorkManualVersion: items[0].WorkManualVersion,
        userCode: items[0].RecordUserCode,
        WorkTypeCode: items[0].WorkTypeCode,
      };
      this.api_page_status(item);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_worker(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_page_logs = async (item) => {
    const { academicYear } = this.state;
    const { DepartmentCode } = item;
    const { token, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const result = await req_list_tqa_department_log(
      academicYear,
      DepartmentCode,
      token
    );
    if (result.total > 0) {
      const logs = result.data;
      this.setState({ logs }, () => {
        this.setState({ isLogModal: true });
      });
    } else {
      const logs = [];
      message.info("查無資料");
      this.setState({ logs });
    }
  };

  api_downloadfile = async (fileUrl) => {
    // download file link
    console.log(fileUrl);
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_page_status = async (item) => {
    const { WorkTypeCode, WorkManualVersion } = item;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const result = await req_single_tqa_reviewCheck(
      WorkManualVersion,
      userCode,
      WorkTypeCode,
      token
    );
    if (result) {
      if (result.RecordStatus === "SUBMIT") {
        this.setState({ isSubmited: true });
      } else {
        this.setState({ isSubmited: false });
      }
    } else {
      this.setState({ isSubmited: false });
    }
  };

  api_single_checkitem = async (item) => {
    const { AcademicYear, WorkTypeCode, WorkManualVersion } = item;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const result = await req_single_tqa_reviewCheck(
      WorkManualVersion,
      userCode,
      WorkTypeCode,
      token
    );
    if (result) {
      this.setState({ checkdata: result }, () => {
        this.setState({ isCheckModal: true });
      });
    } else {
      const checkdata = {
        Uid: "",
        AcademicYear: AcademicYear,
        WorkTypeCode: WorkTypeCode,
        WorkManualVersion: WorkManualVersion,
        ChoicedValueA: "符合",
        ChoicedValueB: "符合",
        ChoicedValueC: "符合",
        ChoicedValueD: "符合",
        ChoicedValueE: "符合",
        RecordUserCode: userCode,
        RecordStatus: "NEWDATA",
      };
      this.setState({ checkdata }, () => {
        this.setState({ isCheckModal: true });
      });
    }
  };

  api_submit_item = async (item) => {
    const { token, userCode, userName } = this.props.user;
    const {
      AcademicYear,
      WorkGuid,
      DepartmentCode,
      DepartmentName,
      WorkManualVersion,
    } = item;
    const obj = {
      WorkManualVersion: WorkManualVersion,
      ContentUserCode: userCode,
      RecordUserCode: userCode,
      condition: "SUBMIT",
    };

    // 1.轉換tb_tqa_reviewOpinion狀態
    await req_edit_tqa_reviewOpinion(obj, token);
    // 2.轉換tb_tqa_reviewCheck狀態
    await req_edit_tqa_reviewCheck(obj, token);
    this.setState({ isSubmited: true }, () => {
      this.api_page_items(1);
      message.success("提交成功");
    });

    const log = {
      LogUid: WorkGuid,
      RecordType: "MAIN",
      DepartmentCode: DepartmentCode,
      RecordDescription:
        AcademicYear +
        "學年度-" +
        userName +
        "提交" +
        DepartmentName +
        "(院內互評)審查紀錄，版號：" +
        WorkManualVersion,
      RecordCreator: userCode,
    };

    await req_add_tqa_log(log, token);
  };

  // 數據配置設定 //////////////////////////////////////////////
  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 中心
        ans = "中心";
        break;
      case "C":
        ans = "學系"; // 學系
        break;
      case "D":
        ans = "碩班"; //碩班
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "gold";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 中心
        ans = "#108ee9";
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      case "D":
        ans = "#f50"; // 碩班
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  style_switch_schedule_text(column) {
    let ans = "其他";
    switch (column) {
      case "INIT":
        ans = "初始化";
        break;
      case "EDIT":
        ans = "規劃中";
        break;
      case "CHECK":
        ans = "簽核中";
        break;
      case "VETO":
        ans = "已退件";
        break;
      case "REVIEW":
        ans = "已送審";
        break;
      case "SUBMIT":
        ans = "已送審";
        break;
      case "DONE":
        ans = "已完成";
        break;
      case "CANCEL":
        ans = "已註銷";
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_schedule_color(column) {
    let ans = "#FFFFFF";
    switch (column) {
      case "INIT":
        ans = "#33ECFF";
        break;
      case "EDIT":
        ans = "#108EE9";
        break;
      case "CHECK":
        ans = "#FF7300";
        break;
      case "VETO":
        ans = "#808080";
        break;
      case "REVIEW":
      case "SUBMIT":
        ans = "#AF982C";
        break;
      case "DONE":
        ans = "#87D068";
        break;
      case "CANCEL":
        ans = "#FF0000";
        break;
      default:
        ans = "#FFFFFF";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////
  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  get_submited_status = (item) => {
    const {
      DepartmentJudgeCodeA,
      DepartmentJudgeStatusA,
      DepartmentJudgeStatusB,
    } = item;
    const { userCode } = this.props.user;
    if (DepartmentJudgeCodeA === userCode) {
      return DepartmentJudgeStatusA === "INIT" ? false : true;
    } else {
      return DepartmentJudgeStatusB === "INIT" ? false : true;
    }
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "log":
        this.api_page_logs(item);
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      case "PREVIEW":
        this.setState({ isPreviewModal: true, item });
        break;
      case "SUBMIT":
        Modal.confirm({
          title: `您確定送出檢核內容，將無法再修改`,
          onOk: () => {
            this.api_submit_item(item);
          },
        });
        break;
      case "CHECK":
        this.setState({ item }, () => this.api_single_checkitem(item));
        break;
      case "OPINION":
        this.setState({ isOpinionModal: true, item });
        break;

      default:
    }
  };

  /////////////////////////////////////////////////////////////

  init_columns = () => {
    const academicYear = getNowAcademicYear(new Date());
    this.setState({ academicYear });
    this.columns = [
      {
        title: "分類",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { WorkTypeCode } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(WorkTypeCode)}>
                {this.style_switch_text_tag(WorkTypeCode)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "單位",
        dataIndex: "DepartmentName",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "品保老師",
        width: 40,
        responsive: ["md"],
        render: (item) => {
          const { AuthorName } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {AuthorName}</span>
            </div>
          );
        },
      },
      {
        title: "進度",
        dataIndex: "RecordStatus",
        width: 20,
        render: (field) => {
          //const { board } = englishactivity
          return (
            <div className="text-center">
              <Tag color={this.style_switch_schedule_color(field)}>
                {this.style_switch_schedule_text(field)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (item) => {
          const { RecordStatus, WorkManualFileUrl } = item;
          const isSubmited = this.get_submited_status(item);
          return (
            <>
              {" "}
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() => this.handle_show_ui_modal("log", item)}
              >
                <i className="fa fa-align-justify"></i>
                <span style={{ marginLeft: "2px" }}>歷程</span>
              </button>
              {RecordStatus === "REVIEW" ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.api_downloadfile(WorkManualFileUrl)}
                  >
                    <i className="fas fa-cloud-download-alt"></i>
                    <span style={{ marginLeft: "4px" }}>檔案</span>
                  </button>
                  {isSubmited ? (
                    <></>
                  ) : (
                    <>
                      <button
                        type="button"
                        className={
                          isSubmited
                            ? "btn btn-outline-success btn-sm"
                            : "btn btn-outline-dark btn-sm"
                        }
                        onClick={() => this.handle_show_ui_modal("CHECK", item)}
                      >
                        <i className="fa fa-check"></i>
                        <span style={{ marginLeft: "2px" }}>勾檢核</span>
                      </button>
                      <button
                        type="button"
                        className={
                          isSubmited
                            ? "btn btn-outline-success btn-sm"
                            : "btn btn-outline-dark btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("OPINION", item)
                        }
                      >
                        <i className="fa fa-th-list"></i>
                        <span style={{ marginLeft: "2px" }}>寫建議</span>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm"
                        onClick={() =>
                          this.handle_show_ui_modal("SUBMIT", item)
                        }
                      >
                        <i className="fa fa-upload"></i>
                        <span style={{ marginLeft: "2px" }}>確認</span>
                      </button>
                    </>
                  )}
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.handle_show_ui_modal("PREVIEW", item)}
                  >
                    <i className="fa fa-eye"></i>
                    <span style={{ marginLeft: "2px" }}>
                      {isSubmited ? "檢視" : "預覽"}
                    </span>
                  </button>
                </>
              ) : null}
            </>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      item,
      items,
      checkdata,
      logs,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isEditModal,
      isLogModal,
      isCheckModal,
      isOpinionModal,
      isPreviewModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="DepartmentName">單位</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isEditModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isEditModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WorkerModifyModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isLogModal}
          width={"600px"}
          onOk={() => {
            this.setState({ isLogModal: false });
          }}
          onCancel={() => {
            this.setState({ isLogModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <HistoryLogsDepartmentModal logs={logs} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isCheckModal}
          width={"70%"}
          okText="關閉"
          onOk={() => {
            this.setState({ isCheckModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isCheckModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ReviewSchoolCheckModal worker={item} checkdata={checkdata} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isOpinionModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isOpinionModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isOpinionModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ReviewSchoolOpinionModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isPreviewModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isPreviewModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isPreviewModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ReviewSchoolBrowseModal worker={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewDepartmentList);
